<!-- Conteúdo da Option List -->
<div class="list-content">
    <ng-content />
</div>
